module.exports = __webpack_public_path__ + "img/briefcase.5e3167eb.svg";